import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { data, useNavigate } from 'react-router-dom';
import './../../styles/cliente/pedidos.css';
import * as globals from '../../components/GlobalScripts.js';

const Cliente_pedidos = () => {
    const [orders, setOrders] = useState([]);
    const [searchDate, setSearchDate] = useState('');
    const [searchState, setSearchState] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate();
    const path_api = localStorage.getItem('path_api');
    const itemsPerPage = 10;

    const getOrders = (page = 1, search = '') => {
        globals.openViewCharge();
        axios.post(`${path_api}/update-orders/get_orders_client.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            page: page,
            itemsPerPage: itemsPerPage,
            search: search,
            searchState: searchState
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setOrders(response.data.orders);
                setTotalPages(response.data.totalPages);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se obtuvieron los pedidos",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar los pedidos",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    useEffect(() => {
        getOrders(currentPage, searchDate);
    }, [currentPage, searchState]);

    const handleSearchDateChange = (e) => {
        const value = e.target.value;
        setSearchDate(value);
        const date = new Date(value);
        if (date.getFullYear() >= 2025) {
            setCurrentPage(1);
            if (currentPage == 1)
                getOrders(currentPage, value);
        }
    };

    const handleSearchStateChange = (e) => {
        setSearchState(e.target.value);
        setCurrentPage(1);
    };

    const handlePrevPage = () => {
        setCurrentPage(prev => Math.max(prev - 1, 1));
    };

    const handleNextPage = () => {
        setCurrentPage(prev => Math.min(prev + 1, totalPages));
    };

    const handlePlatillo = (platillo, id) => {
        platillo.id = id;
        localStorage.setItem('platillo', JSON.stringify(platillo));
        navigate(`/cliente/pedidos/calificar`);
    };

    return (
        <div className="page-pedidos container-section flex-column gap-20">
            <h3>Listado de pedidos</h3>
            <div className="container-search">
                <div className='search'>
                    <label>Fecha de inicio:</label>
                    <input type="date" value={searchDate} onChange={handleSearchDateChange} className="input-primary" />
                </div>
                <div className='search'>
                    <label>Estado:</label>
                    <select value={searchState} onChange={handleSearchStateChange} className="input-primary">
                        <option value="">Todos</option>
                        <option value="entregado">Entregado</option>
                        <option value="cancelado">Cancelado</option>
                    </select>
                </div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Fecha</th>
                        <th>Usuario</th>
                        <th>Platillo Seleccionado</th>
                        <th>Estado</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {orders.map(order => (
                        <tr key={order.id}>
                            <td>{order.id}</td>
                            <td>{order.order_date}</td>
                            <td>{order.email}</td>
                            <td>{order.dish_info?.name}</td>
                            <td>{order.status}</td>
                            <td className="table-actions">
                                {order.status != "cancelado" && !order.review_exists && (
                                    <button className="edit-button" onClick={() => handlePlatillo(order.dish_info, order.id)} title='calificar'>
                                        <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g >
                                                <path d="M22.575 96.5187C20.1625 97.7562 17.425 95.5875 17.9125 92.8187L23.1 63.2563L1.08125 42.2813C-0.975 40.3188 0.0937499 36.7313 2.85 36.3438L33.4625 31.9938L47.1125 4.95C48.3438 2.5125 51.675 2.5125 52.9063 4.95L66.5563 31.9938L97.1687 36.3438C99.925 36.7313 100.994 40.3188 98.9313 42.2813L76.9188 63.2563L82.1063 92.8187C82.5938 95.5875 79.8562 97.7562 77.4437 96.5187L50 82.4188L22.575 96.5187Z" fill="black" />
                                            </g>
                                        </svg>
                                    </button>
                                )}
                                {(order.status == "cancelado" || order.review_exists == 1) && (
                                    <p>N/A</p>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="pagination">
                <button className="button-pagination" onClick={handlePrevPage} disabled={currentPage === 1}>
                    Anterior
                </button>
                <p>Página {currentPage} de {totalPages}</p>
                <button className="button-pagination" onClick={handleNextPage} disabled={currentPage === totalPages}>
                    Siguiente
                </button>
            </div>
        </div>
    );
};

export default Cliente_pedidos;